import { useState } from "react";
import { Link } from "react-router-dom";
import { FloppyDisk, Plus, Trash } from "@phosphor-icons/react";
import api from "../../../lib/api";
import { useBrand } from "../../../context/BrandContext";
import { ScheduleTab } from "../../../pages/Reporting";
import PoLedger from "../PoLedger";
import PoBatches from "../PoBatches";
import SubmitReport from "../SubmitReport";
import JubelioVerification from "../JubelioVerification";
import ModeSwitch from "../ModeSwitch";
import { btnGhost, btnPrimary, inp, todayWIB } from "../util";
import { Card, call, useLoad } from "./common";

function ConfigForm({ cfg, onSaved }) {
    const [c, setC] = useState({ po_countries: cfg.po_countries, rate_orange: cfg.rate_orange, rate_green: cfg.rate_green });
    const [n, setN] = useState("");
    return (
        <Card title="Kategori PO & batas rate closing" testid="setting-config">
            <div className="flex flex-wrap gap-2 mb-3">
                {c.po_countries.map((x) => <span key={x} className="inline-flex items-center gap-1 border border-mist px-2 py-1 text-sm rounded-sm" data-testid={`po-country-${x}`}>PO {x}<button type="button" aria-label="Hapus" onClick={() => setC({ ...c, po_countries: c.po_countries.filter((y) => y !== x) })}><Trash size={12} /></button></span>)}
            </div>
            <div className="flex gap-2 mb-4"><input value={n} onChange={(e) => setN(e.target.value)} placeholder="Negara PO baru, mis. Korea" className={inp} data-testid="po-country-input" />
                <button type="button" className={btnGhost} onClick={() => { if (n.trim()) { setC({ ...c, po_countries: [...c.po_countries, n.trim()] }); setN(""); } }} data-testid="po-country-add"><Plus size={14} /> Tambah</button></div>
            <div className="grid grid-cols-2 gap-3">
                <label className="text-xs text-neutral-500">Oranye mulai (%)<input type="number" step="0.5" value={c.rate_orange} onChange={(e) => setC({ ...c, rate_orange: Number(e.target.value) })} className={`${inp} mt-1`} data-testid="rate-orange" /></label>
                <label className="text-xs text-neutral-500">Hijau mulai (%)<input type="number" step="0.5" value={c.rate_green} onChange={(e) => setC({ ...c, rate_green: Number(e.target.value) })} className={`${inp} mt-1`} data-testid="rate-green" /></label>
            </div>
            <p className="text-[11px] text-neutral-400 mt-2">Di bawah batas oranye = Merah (Perlu Improvement). Menghapus kategori tidak menghapus data lama.</p>
            <button type="button" className={`${btnPrimary} mt-3`} onClick={async () => { if (await call(() => api.put("/reporting/v2/config", c), "Setting disimpan")) onSaved(); }} data-testid="config-save"><FloppyDisk size={14} /> Simpan</button>
        </Card>
    );
}

function Targets() {
    const [month, setMonth] = useState(todayWIB().slice(0, 7));
    const [admins] = useLoad("/reporting/v2/recipients");
    const [t, , setT] = useLoad("/reporting/v2/targets", { month });
    if (!admins || !t) return null;
    return (
        <Card title="Target penjualan bulanan per Admin Sales aktif (Ready + PO)" testid="setting-targets">
            <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className={`${inp} !w-44 mb-3`} data-testid="target-month" />
            {admins.map((a) => (
                <label key={a.id} className="flex items-center justify-between gap-3 py-1 text-sm">{a.name}
                    <input inputMode="numeric" value={t[a.id] ? Number(t[a.id]).toLocaleString("id-ID") : ""} placeholder="Rp 0" onChange={(e) => setT({ ...t, [a.id]: parseInt(e.target.value.replace(/\D/g, "") || "0", 10) })} className={`${inp} !w-44 tabular-nums`} data-testid={`target-${a.name}`} /></label>
            ))}
            {admins.length === 0 && <p className="text-sm text-neutral-400">Belum ada Admin Sales aktif.</p>}
            <button type="button" className={`${btnPrimary} mt-3`} onClick={() => call(() => api.put("/reporting/v2/targets", { month, targets: t }), "Target disimpan")} data-testid="targets-save"><FloppyDisk size={14} /> Simpan target</button>
        </Card>
    );
}

const SUB = [["umum", "Umum"], ["po", "Buku PO"], ["batch", "Batch PO"], ["excel", "Excel"], ["jubelio", "Cek Jubelio (per brand)"], ["jadwal", "Jadwal"], ["mode", "Mode Laporan"]];

export default function Setting({ cfg, onSaved, isOwner }) {
    const { current } = useBrand();
    const [sub, setSub] = useState("umum");
    return (
        <div className="space-y-4" data-testid="v2-setting">
            {isOwner && <div className="flex flex-wrap gap-1">{SUB.map(([k, l]) => <button key={k} type="button" onClick={() => setSub(k)} className={`px-3 py-1.5 text-xs rounded-sm border ${sub === k ? "bg-ink text-white border-ink" : "border-mist"}`} data-testid={`setting-sub-${k}`}>{l}</button>)}</div>}
            {sub === "umum" && (
                <div className="grid md:grid-cols-2 gap-4">
                    {isOwner && <Card title="Daftar Akses" testid="setting-access">
                        <p className="text-sm text-neutral-600">Kelola akun, role (Admin Sales, Finance, Supervisor), status aktif. Semua Admin Sales aktif dapat mengisi Sales Closing. Admin Sales aktif otomatis muncul sebagai penerima handover.</p>
                        <Link to="/settings/users" className={`${btnGhost} mt-3`} data-testid="setting-users-link">Buka Daftar Akses</Link>
                    </Card>}
                    <ConfigForm cfg={cfg} onSaved={onSaved} />
                    <Targets />
                </div>
            )}
            {sub === "po" && <PoLedger brand={current} refreshKey={0} />}
            {sub === "batch" && <PoBatches />}
            {sub === "excel" && <SubmitReport brand={current} onSubmitted={() => setSub("po")} />}
            {sub === "jubelio" && <JubelioVerification />}
            {sub === "jadwal" && <ScheduleTab />}
            {isOwner && sub === "mode" && <ModeSwitch />}
        </div>
    );
}
